
import Vue from "vue";
import Component from "vue-class-component";
import { Getter, State } from "vuex-class";
import { Prop, Emit } from "vue-property-decorator";
import BreadcrumbRegister from "@/components/register/BreadcrumbRegister.vue";
@Component({
  components: {
    BreadcrumbRegister,
  },
})
export default class HeaderRegister1 extends Vue {
  @State("school", { namespace: "school" })
  school!: any;
  @State("template", { namespace: "school" })
  template!: any;

  @Prop({ default: false }) isHighSchool!: boolean;
  @Prop({ default: false }) canReSendOtp!: boolean;
  @Prop({ default: null }) candidateId!: any;
  @Prop({ default: false }) isTracer!: boolean;
  @Prop({ default: null }) onDegreeChange!: any;
  @Prop({ default: null }) onProvinceChange!: any;
  @Prop({ default: null }) onlyNumber!: any;
  @Prop({ default: false }) isEmail!: boolean;
  @Prop({ default: null }) sendOtp!: any;
  @Prop({ default: null }) user!: any;
  @Prop({ default: [] }) degrees!: Array<any>;
  @Prop({ default: [] }) majors!: Array<any>;
  @Prop({ default: [] }) provinces!: Array<any>;
  @Prop({ default: [] }) cities!: Array<any>;
  @Prop({ default: 1 }) step!: number;
  @Prop({ default: "" }) otpTimer!: string;
  @Prop({ default: false }) isReSendOtp!: boolean;
  @Prop({ default: "" }) otp!: string;
  @Prop({ default: [] }) genders!: Array<any>;
  @Prop({ default: [] }) icons!: Array<any>;
  @Prop({ default: false }) tokenValid!: boolean;
  @Prop({ default: false }) eventActive!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: "" }) eventEndDate!: string;

  CopyToClipboard = require("copy-to-clipboard");

  section: "intro" | "uniq-code" | "register" = "intro";

  @Emit("changeStep")
  public changeStep(index: number) {}

  @Getter("twoColor") twoColor!: {
    text: string;
    bg: string;
    border: string;
  };

  get twoBgColor() {
    return this.twoColor.bg;
  }

  get emptyQueryCode() {
    if (this.$route.query.code === undefined) return true;

    if (this.$route.query.code === null || this.$route.query.code === "")
      return true;

    return false;
  }

  setOtp(event: Event & { target?: any }) {
    this.$emit("update:otp", event.target?.value);
  }
}
